module.exports = __webpack_public_path__ + "assets/img/871587018203_.pic_hd.87867341.jpg";